"use client";

import React, { createContext, useContext, useState, type ReactNode } from "react";

interface MobileFilterContextValue {
    showMobileFilters: boolean;
    setShowMobileFilters: (show: boolean) => void;
}

const MobileFilterContext = createContext<MobileFilterContextValue | null>(null);

/**
 * Thin client provider that owns the mobile-filter toggle state.
 *
 * Wrapping the page layout in this provider lets TopSearchBar and
 * SearchSideOptimized share the toggle without forcing the entire
 * layout tree into a single "use client" boundary.
 */
export function MobileFilterProvider({ children }: { children: ReactNode }) {
    const [showMobileFilters, setShowMobileFilters] = useState(false);

    return (
        <MobileFilterContext.Provider value={{ showMobileFilters, setShowMobileFilters }}>
            {children}
        </MobileFilterContext.Provider>
    );
}

export function useMobileFilter(): MobileFilterContextValue {
    const ctx = useContext(MobileFilterContext);
    if (!ctx) {
        throw new Error("useMobileFilter must be used within a MobileFilterProvider");
    }
    return ctx;
}
